import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { IResponse } from '@shared/models/base/http-response.model';
import { MarkDefinition } from '@shared/components/organisms/search-bar/models/mark-definition.model';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class MarkDefinitionsService {
  http = inject(HttpClient);

  getMarkDefinitions(): Observable<IResponse<MarkDefinition[]>> {
    //return of(MARK_DEFINITIONS_RESPONSE).pipe(delay(250))
    // const params = new HttpParams()
    //   .set('proposalId', proposalId);

    return this.http.get<IResponse<MarkDefinition[]>>(
      new URL('misc/GetDocumentMark', environment.apiUrl).href,
    );
  }
}
